import React from "react";
import { Modal } from "react-bootstrap";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField/index";
import Select from "@material-ui/core/Select";

export default function Filter(props) {
  const { onHide, show, filterInputsUpdate, filterInputs } = props;
  const [role, setRole] = React.useState("");
  const [open, setOpen] = React.useState(false);

  function handleChange(event) {
    setRole(event.target.value);
    filterInputsUpdate(event);
  }

  function handleClose() {
    setOpen(false);
  }

  function handleOpen() {
    setOpen(true);
  }
  return (
    <Modal
      size="sm"
      show={show}
      onHide={onHide}
      aria-labelledby="create"
      centered
      className="modal-right pr-0"
    >
      <Modal.Header closeButton>
        <Modal.Title id="create">Users filter</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="col-12 pl-4 pr-4">
          <div className="row">
            <div className="col-12 col-md-12 col-lg-12">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                <TextField
                  id="firstName"
                  name="firstName"
                  label="First name"
                  placeholder="First name"
                  className="w-100"
                  value={filterInputs.firstName}
                  onChange={(e) => filterInputsUpdate(e)}
                />
              </div>
            </div>
            <div className="col-12 col-md-12 col-lg-12">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                <TextField
                  id="lastName"
                  name="lastName"
                  label="Last name"
                  placeholder="Last name"
                  className="w-100"
                  value={filterInputs.lastName}
                  onChange={(e) => filterInputsUpdate(e)}
                />
              </div>
            </div>
            <div className="col-12 col-md-12 col-lg-12">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                <TextField
                  id="email"
                  name="email"
                  label="Email"
                  placeholder="Email"
                  className="w-100"
                  value={filterInputs.email}
                  onChange={(e) => filterInputsUpdate(e)}
                />
              </div>
            </div>
            <div className="col-12 col-md-12 col-lg-12">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                <FormControl className="w-100">
                  <InputLabel htmlFor="role">Role</InputLabel>
                  <Select
                    open={open}
                    onClose={handleClose}
                    onOpen={handleOpen}
                    value={role}
                    onChange={handleChange}
                    inputProps={{
                      name: "roleId",
                      id: "roleId",
                    }}
                  >
                    <MenuItem value="">All</MenuItem>
                    <MenuItem value={0}>Admin</MenuItem>
                    <MenuItem value={1}>User</MenuItem>
                    <MenuItem value={2}>Call Center</MenuItem>
                  </Select>
                </FormControl>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
